import * as types from '../mutation-types'
import studentService from '../../services/students'

const state = {
  loading: false,
  errors: '',
  students: []
}

const actions = {
  getAll({ commit }) {
    commit(types.STUDENT_LOADING, true)
    studentService.getAll().then(
      response => {

        commit(types.LOAD_STUDENTS, response.data)
        commit(types.STUDENT_LOADING, false)
        commit(types.STUDENT_FAILURE, null)
      },
      error => {
        commit(types.STUDENT_FAILURE, error)
        commit(types.STUDENT_LOADING, false)
      }
    )
  },
  add({ commit }, data) {
    commit(types.STUDENT_LOADING, true)
    commit(types.STUDENT_FAILURE, null)
    return studentService.add(data).then(
      response => {
        data.id = response.data.id
        data.s_bio = response.data.s_bio
        data.s_class = response.data.s_class
        data.s_guardian = response.data.s_guardian
        commit(types.ADD_STUDENT, response.data)
        commit(types.STUDENT_LOADING, false)
        return response
      },
      error => {
        commit(types.STUDENT_FAILURE, error)
        commit(types.STUDENT_LOADING, false)
        throw error
      }
    )
  },
  update({ commit }, data) {
    commit(types.STUDENT_LOADING, true)
    commit(types.STUDENT_FAILURE, null)
    studentService.update(data.student)
      .then(
        response => {
          data.student.s_bio = response.data.s_bio
          data.student.s_class = response.data.s_class
          data.student.s_guardian = response.data.s_guardian
          commit(types.UPDATE_STUDENT, data)
          commit(types.STUDENT_LOADING, false)

        },
        error => {
          commit(types.STUDENT_FAILURE, error)
          commit(types.STUDENT_LOADING, false)
        }
      )


  },
  delete({ commit }, data) {
    commit(types.STUDENT_LOADING, true)
    commit(types.STUDENT_FAILURE, null)
    studentService.delete(data.student.id)
      .then(
        response => {
          commit(types.DELETE_STUDENT, data)
          commit(types.STUDENT_LOADING, false)
        },
        error => {
          commit(types.STUDENT_FAILURE, error)
          commit(types.STUDENT_LOADING, false)
        }
      )
  },

  promote({ commit,dispatch }, data) {
    studentService.runpromotion(data).then(
      resp => {
          if(resp.status == 208){
            // dispatch("responseMessage", {
            //   type: "success",
            //   text: "Students have already been promoted for the current academic year. (Note: please check if the right academic year is set in settings)",
            //   title: "Promotions",
            //   modal: false
            // },{root:true});

            alert(resp.data);
          }else if(resp.status==200){
            dispatch("responseMessage", {
              type: "success",
              text: resp.data,
              title: "Promotions",
              modal: false
            },{root:true});
          }
          commit(types.STUDENT_FAILURE, null)
      },
      error => {
        commit(types.STUDENT_FAILURE, error)
        commit(types.STUDENT_LOADING, false)
      }
    )
  }
}

const mutations = {
  [types.ADD_STUDENT](state, payload) {
    state.students.unshift(payload);
  },
  [types.LOAD_STUDENTS](state, payload) {
    state.students = payload
  },
  [types.UPDATE_STUDENT](state, payload) {
    Object.assign(state.students[payload.index], payload.student);
  },
  [types.DELETE_STUDENT](state, payload) {
    state.students.splice(payload.index, 1)
  },
  [types.STUDENT_FAILURE](state, payload) {
    state.errors = payload
  },

  [types.STUDENT_LOADING](state, payload) {
    state.loading = payload
  },
}


const getters = {
  STUDENTS: state => {
    return state.students
  },

  STUDENT_ERROR: state => {
    return state.errors
  },

  STUDENT_LOADING: state => {
    return state.loading
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/students.js